<template lang="html">
  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper auth">
        <div
          class="content-wrapper d-flex align-items-center login-half-bg"
          :style="{ backgroundImage: `url(${loginPage_bg})` }"
        >
          <div class="row w-100 flex-grow align-items-center">
            <!-- Bus image section -->
            <div
              class="col-md-6 d-flex justify-content-center align-items-center overflow-hidden"
            >
              <img class="bus-img" :src="busImg" alt="Bus" />
            </div>
            <!-- Login card -->
            <div class="col-md-5 d-flex justify-content-center">
              <div class="auth-form-light text-center p-5 login-card">
                <div class="brand-logo">
                  <img class="img" :src="busIcon" />
                </div>
                <h5 class="login-header-text">Admin Login</h5>
                <Login />

                <div class="float-right">
                  <router-link
                    target="_blank"
                    class="text-small forgot-password text-black mr-3"
                    to="/terms"
                    >Terms and condition</router-link
                  >

                  <router-link
                    target="_blank"
                    class="text-small forgot-password text-black mr-3"
                    to="/privacy-policy"
                    >Privacy policy</router-link
                  >

                  <router-link
                    target="_blank"
                    class="text-small forgot-password text-black mr-3"
                    to="/refund-policy"
                    >Refund policy</router-link
                  >
                </div>
              </div>
            </div>
            <p class="">
              copyright © {{ this.$year }} {{ appName }}. All rights reserved.
            </p>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>
</template>

<script lang="js">
import Login from '../../components/auth/Login';
import { useApp }  from "../../store/useApp"
import { mapState } from "pinia";
import loginPage_bg from '../../assets/images/auth/loginPage_bg.png';
import busIcon from '../../assets/images/auth/busIcon.png';
import busImg from '../../assets/images/auth/busImg.png'
export default {
  name: 'login',
  components:{
      Login
  },
  data(){
    return{
      loginPage_bg,
      busIcon,
      busImg
    }
  },
  mounted(){
    this.fetchApp();

  },
  computed:{
        ...mapState(useApp, ["appName","appLogo"]),
  },
  methods:{
    fetchApp(){
   const app = useApp()
      app.getApp();
    }
  }
}
</script>

<style scoped></style>
